import gql from 'graphql-tag';

export default gql`
  mutation continueButtonMutation(
    $departureFlightId: ID!
    $departureFareName: String!
    $returningFlightId: ID
    $returningFareName: String
    $selectedBundles: SelectedBundlesInput
  ) {
    selectFlights(
      departureFlightId: $departureFlightId
      returningFlightId: $returningFlightId
      selectedBundles: $selectedBundles
      departureFareName: $departureFareName
      returningFareName: $returningFareName
    ) {
      transactionId
      order {
        status
        travelers {
          id
        }
        price {
          total
        }
      }
      errors
    }
  }
`;
